// Formateo de presentación (D-005, D-006): moneda COP y fechas DD/MM/AAAA.
import { formatCOP, money } from "@tiger/shared";

/** `$ 1.234.567,89`. Acepta strings de la API (NUMERIC serializado). */
export function formatMoney(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === "") return "—";
  try {
    return formatCOP(money(v));
  } catch {
    return "—";
  }
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

/** DD/MM/AAAA a partir de un ISO string o "YYYY-MM-DD". */
export function formatDate(v: string | null | undefined): string {
  if (!v) return "—";
  // date puro "YYYY-MM-DD" → no aplicar timezone para evitar corrimiento.
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.exec(v);
  if (dateOnly) {
    const [y, m, d] = v.split("-");
    return `${d}/${m}/${y}`;
  }
  const dt = new Date(v);
  if (Number.isNaN(dt.getTime())) return "—";
  return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()}`;
}

/** DD/MM/AAAA HH:mm. */
export function formatDateTime(v: string | null | undefined): string {
  if (!v) return "—";
  const dt = new Date(v);
  if (Number.isNaN(dt.getTime())) return "—";
  return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
}

/** Valor de un <input type="date"> a partir de una fecha ISO o null. */
export function toDateInput(v: string | null | undefined): string {
  if (!v) return "";
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(v);
  return m && m[1] ? m[1] : "";
}

/** Iniciales para avatares. */
export function initials(first?: string | null, last?: string | null): string {
  const a = (first ?? "").trim();
  const b = (last ?? "").trim();
  return `${a.charAt(0)}${b.charAt(0)}`.toUpperCase() || "?";
}
